import { useGlobalStore } from "@/store/GlobalStore";
import { useNotificationStore } from "@/store2/notification/notification-store";
import { Channel, TopicType } from "project-config/constants";
import { isEn, isFox } from "project-config/utils/env";
import { useCallback, useEffect, useRef } from "react";
import { TaskSocket } from "task-socket";

export function useTaskSocket() {
  const taskSocketRef = useRef<TaskSocket | null>(null);
  const { userInfo } = useGlobalStore();
  const setNotificationStore = useNotificationStore((s) => s.setter);

  const handleSystemNotice = useCallback(
    (msgObj: Record<string, any>) => {
      const { contentEn, contentZh, platform, channels } = msgObj;
      const isFoxChannel = isFox && channels.includes(Channel.FoxWeb);
      const isRenderbusChannel =
        !isFox && channels.includes(Channel.RenderbusWeb);
      if (!isFoxChannel && !isRenderbusChannel) return;
      const content: string = isEn() ? contentEn : contentZh;
      setNotificationStore((s) => {
        const platformList: number[] = JSON.parse(platform) || [];
        if (platformList.includes(userInfo?.platform || 0)) {
          s.platformNotice = content;
          s.platformNoticeModal = content;
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userInfo?.platform]
  );

  const dealWithMessage = (msg: string) => {
    if (!msg) return;
    const msgObj = JSON.parse(msg);
    const { business } = msgObj;
    if (business === TopicType.SystemNotice) {
      handleSystemNotice(msgObj);
    }
  };

  useEffect(() => {
    if (!userInfo?.userId) return;
    if (!taskSocketRef.current) {
      taskSocketRef.current = new TaskSocket();
    }
    if (taskSocketRef.current.hasInitialized) return;
    taskSocketRef.current
      .init({
        userId: userInfo.userId,
      })
      .onMessage((frameObject) => {
        const msg = String(frameObject.body || "");
        dealWithMessage(msg);
      });
    return () => {
      taskSocketRef.current?.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.userId]);
}
